(function($) {
    const escapeHtml = (value) => {
      if (value === null || value === undefined) return '';
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };

    const escapeAttribute = (value) => encodeURI(value || '');

    $(document).ready(function() {
      $('.studiothink-property-map__container').each(function() {
        const $container = $(this);
        const $block = $container.closest('.wp-block-st-property-map');
        const lat  = parseFloat($container.data('lat')) || 54.8789894;
        const lng  = parseFloat($container.data('lng')) || -93.7517458;
        const zoom = parseInt($container.data('zoom'), 10) || 3;
  
        if (typeof mapboxgl === 'undefined' || typeof propertyMapVars === 'undefined') {
          console.error('Mapbox GL JS or propertyMapVars missing.');
          return;
        }
  
        // Mapbox token
        mapboxgl.accessToken = propertyMapVars.accessToken;
  
        // Init map
        const map = new mapboxgl.Map({
          container: $container[0],
          style: propertyMapVars.defaultStyle,
          center: [lng, lat],
          zoom: zoom,
          attributionControl: false
        });
  
        // Add controls ONCE
        const nav = new mapboxgl.NavigationControl();
        map.addControl(nav, 'top-right');
  
        // Create a popup, but don't add it to the map yet
        const popup = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: false,
            maxWidth: '320px',
            offset: [0, -40]
        });

        // Track if list is currently being filtered by map bounds
        let boundsFilterActive = false;

        // Helper: update the results count in the list header
        // If bounds filtering is active, count in-bounds matches (regardless of pagination visibility)
        // Otherwise, count all items in the list
        function updateResultsCountFromDom() {
          const $list = $block.find('.studiothink-property-map__list-container');
          const $count = $block.find('.results-count__number');
          if (!$count.length) return;
          let total;
          if (boundsFilterActive) {
            total = $list.find('.studiothink-property-map__list-item.in-bounds').length;
          } else {
            total = $list.find('.studiothink-property-map__list-item').length;
          }
          $count.text(total);
        }

        // Helper: show all list items and sync pagination/count
        function showAllListItems() {
          const $list = $block.find('.studiothink-property-map__list-container');
          $list.find('.studiothink-property-map__list-item').removeClass('in-bounds').show();
          computePaginationFromDom();
          renderPaginationPage(1, { scroll: false });
          updateResultsCountFromDom();
        }

        // Apply current map bounds to filter list items using propertyMapVars.properties (permalink match)
        function applyBoundsToList() {
          const properties = Array.isArray(propertyMapVars.properties) ? propertyMapVars.properties : [];
          if (!properties.length) {
            showAllListItems();
            return;
          }
          const b = map.getBounds();
          if (!b) {
            showAllListItems();
            return;
          }
          // Build a padded bounds in pixel space to avoid excluding markers near the edges
          const canvas = map.getCanvas();
          const vw = canvas ? canvas.width : 0;
          const vh = canvas ? canvas.height : 0;
          // Dynamic padding: 10% of the smaller viewport dimension, clamped between 50px and 300px
          const padPx = Math.max(50, Math.min(300, Math.round(Math.min(vw, vh) * 0.15)));
          const swPx = map.project(b.getSouthWest());
          const nePx = map.project(b.getNorthEast());
          swPx.x -= padPx; swPx.y += padPx; // extend left and down
          nePx.x += padPx; nePx.y -= padPx; // extend right and up
          const paddedBounds = new mapboxgl.LngLatBounds(map.unproject(swPx), map.unproject(nePx));
          const inBoundsPermalinks = new Set();
          properties.forEach(p => {
            if (typeof p.lng === 'number' && typeof p.lat === 'number') {
              if (paddedBounds.contains([p.lng, p.lat])) {
                if (p.permalink) inBoundsPermalinks.add(String(p.permalink));
              }
            }
          });

          const $list = $block.find('.studiothink-property-map__list-container');
          const $items = $list.find('.studiothink-property-map__list-item');

          // If nothing in bounds, hide all items (0 results)
          if (inBoundsPermalinks.size === 0) {
            $items.removeClass('in-bounds').hide();
            // Re-apply current sort order even with no results
            const currentSort = $block.find('#sort-by').val() || 'Default';
            sortListItems(currentSort, { scroll: false });
            return;
          }

          $items.each(function() {
            const href = this.getAttribute('href');
            if (href && inBoundsPermalinks.has(href)) {
              $(this).addClass('in-bounds').show();
            } else {
              $(this).removeClass('in-bounds').hide();
            }
          });

          // Re-apply current sort order after bounds filtering
          const currentSort = $block.find('#sort-by').val() || 'Default';
          sortListItems(currentSort, { scroll: false });
        }

        // Helper to build popup HTML consistently from feature properties
        const buildPopupHtml = (props = {}) => {
            const {
              title = '',
              listingType = '',
              propertyType = '',
              price = '',
              location: locationLabel = '',
              size = '',
              permalink = '',
              thumbnail = ''
            } = props;

            const safeTitle = escapeHtml(title);
            const overlayHtml = listingType ? `<span class="property-popup__image-overlay is-style-h5">${escapeHtml(listingType)}</span>` : '';
            const imageHtml = thumbnail ? `<img src="${escapeAttribute(thumbnail)}" alt="${safeTitle}" class="attachment-post-thumbnail size-post-thumbnail wp-post-image" loading="lazy">` : '<img  fetchpriority="high" decoding="async" width="200" height="150" src="/wp-content/themes/studiothink/assets/images/placeholder.png" alt="Property placeholder" loading="lazy" class="attachment-full size-full wp-post-image" />';
            const propertyTypeHtml = propertyType ? `<span class="property-popup__property-type has-text-color has-midgrey-color">${propertyType}</span>` : '';
            const priceHtml = price ? `<h3 class="property-popup__price is-style-h4 has-text-color has-blue-color">${price}</h3>` : '';
            const titleHtml = safeTitle ? `<h3 class="property-popup__listing-name is-style-h4 has-text-color has-midgrey-color">${safeTitle}</h3>` : '';

            let rowHtml = '<div class="row"><p class="has-text-color has-midgrey-color">' + locationLabel + '</p><p class="has-text-color has-midgrey-color">' + size + '</p></div>';

            return `<div class="property-popup">
                    <a href="${permalink}" class="property-popup__link">
                    <div class="property-popup__image">
                       ${imageHtml}
                       ${overlayHtml}
                    </div>
                    <div class="property-popup__content">
                        ${propertyTypeHtml}
                        ${priceHtml}
                        ${titleHtml}
                        ${rowHtml}
                    </div>
                </a>
            </div>`;
        };

        // Mapbox Spiderifier instance (from libs bundle)
        let spiderifier = null;
        let spiderifiedPointMarker = null;

  
        // Handlers are defined once so we can safely remove/add them across style changes
        const handleClusterClick = (e) => {
            const features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
            if (!features || !features.length) return;
            const clusterFeature = features[0];
            const clusterId = clusterFeature.properties.cluster_id;
            const src = map.getSource('properties');
            if (!src || !src.getClusterExpansionZoom) return;
            // Unspiderfy any current legs and zoom into the cluster
            if (spiderifier && typeof spiderifier.unspiderfy === 'function') {
              spiderifier.unspiderfy();
              if (spiderifiedPointMarker) {
                spiderifiedPointMarker.remove();
                spiderifiedPointMarker = null;
              }
            }
            src.getClusterExpansionZoom(clusterId, (err, nextZoom) => {
              if (err) return;
              map.easeTo({ center: clusterFeature.geometry.coordinates, zoom: nextZoom });
            });
        };
  
        const handlePointClick = (e) => {
            const f = e.features && e.features[0];
            if (!f) return;
            const coordinates = f.geometry.coordinates.slice();

            // Find all rendered unclustered points at this pixel and filter to exact same coordinates
            const rendered = map.queryRenderedFeatures(e.point, { layers: ['unclustered-point'] }) || [];
            const sameCoord = rendered.filter(rf => {
                const c = rf && rf.geometry && rf.geometry.coordinates;
                return Array.isArray(c) && c.length === 2 && c[0] === coordinates[0] && c[1] === coordinates[1];
            });

            if (sameCoord.length > 1 && window.MapboxglSpiderifier) {
                if (!spiderifier) {
                    spiderifier = new window.MapboxglSpiderifier(map, {
                        // Tune spacing/radius
                        circleFootSeparation: 40, // default 25
                        spiralFootSeparation: 36, // default 28
                        spiralLengthStart: 24,    // default 15
                        spiralLengthFactor: 5,    // default 4
                        onClick: function(ev, spiderLeg){
                            // Prevent map-wide click handlers from firing
                            if (ev && ev.stopPropagation) ev.stopPropagation();
                            if (ev && ev.originalEvent && ev.originalEvent.stopPropagation) ev.originalEvent.stopPropagation();
                            const props = spiderLeg && spiderLeg.feature ? spiderLeg.feature : {};
                            const lngLat = spiderLeg && spiderLeg.mapboxMarker && spiderLeg.mapboxMarker.getLngLat ? spiderLeg.mapboxMarker.getLngLat() : null;
                            if (!lngLat) return;
                            const html = buildPopupHtml(props);
                            popup.remove();
                            // Keep global popup offset; do not override with spider-leg specific offset
                            popup.setLngLat([lngLat.lng, lngLat.lat]).setHTML(html).addTo(map);
                        },
                        initializeLeg: function(spiderLeg){
                            const containerEl = spiderLeg && spiderLeg.elements && spiderLeg.elements.container;
                            if (!containerEl) return;
                            containerEl.addEventListener('click', function(ev){
                                // Prevent background map click from firing
                                if (ev && ev.stopPropagation) ev.stopPropagation();
                                if (ev && ev.preventDefault) ev.preventDefault();
                                const props = spiderLeg && spiderLeg.feature ? spiderLeg.feature : {};
                                const lngLat = spiderLeg && spiderLeg.mapboxMarker && spiderLeg.mapboxMarker.getLngLat ? spiderLeg.mapboxMarker.getLngLat() : null;
                                if (!lngLat) return;
                                const html = buildPopupHtml(props);
                                popup.remove();
                                // Keep global popup offset; do not override with spider-leg specific offset
                                popup.setLngLat([lngLat.lng, lngLat.lat]).setHTML(html).addTo(map);
                            }, { capture: true });
                        }
                    });
                }
                if (spiderifier && spiderifier.unspiderfy) spiderifier.unspiderfy();

                // Add a marker to show the spiderified point
                if (spiderifiedPointMarker) {
                  spiderifiedPointMarker.remove();
                }
                const markerEl = document.createElement('div');
                markerEl.className = 'spiderified-point-marker';
                
                // Add count to the marker
                const countEl = document.createElement('div');
                countEl.className = 'spiderified-point-count';
                countEl.textContent = sameCoord.length;
                markerEl.appendChild(countEl);
                
                spiderifiedPointMarker = new mapboxgl.Marker(markerEl)
                  .setLngLat(coordinates)
                  .addTo(map);

                // Handle unspiderfy event
                $(spiderifier).off('unspiderfy').on('unspiderfy', function() {
                    if (spiderifiedPointMarker) {
                        spiderifiedPointMarker.remove();
                        spiderifiedPointMarker = null;
                    }
                });

                const markers = sameCoord.map(rf => (rf && rf.properties) || {});
                spiderifier.spiderfy(coordinates, markers);
                return;
            }

            const popupContent = buildPopupHtml(f.properties || {});
            popup.remove();
            popup.setLngLat(coordinates).setHTML(popupContent).addTo(map);
        };
  
        const handleMouseEnter = () => { map.getCanvas().style.cursor = 'pointer'; };
        const handleMouseLeave = () => { map.getCanvas().style.cursor = ''; };
  
        // Fit the map view to current properties in propertyMapVars.properties
        function fitMapToProperties() {
            const properties = Array.isArray(propertyMapVars.properties) ? propertyMapVars.properties : [];
            if (!properties.length) return;
  
            if (properties.length === 1) {
                const single = properties[0];
                if (typeof single.lng === 'number' && typeof single.lat === 'number') {
                    map.easeTo({ center: [single.lng, single.lat], zoom: 10, duration: 600 });
                }
                return;
            }
  
            const bounds = new mapboxgl.LngLatBounds();
            properties.forEach(prop => {
                if (typeof prop.lng === 'number' && typeof prop.lat === 'number') {
                    bounds.extend([prop.lng, prop.lat]);
                }
            });
            if (!bounds.isEmpty()) {
                map.fitBounds(bounds, { padding: { top: 100, right: 100, bottom: 100, left: 100 }, duration: 700, maxZoom: 12 });
            }
        }
  
        // Define once in outer scope so it is available after style changes
        const addPropertyLayers = () => {
            const properties = Array.isArray(propertyMapVars.properties) ? propertyMapVars.properties : [];

            ['cluster-count','clusters','unclustered-point'].forEach(id => {
                if (map.getLayer(id)) map.removeLayer(id);
            });
            if (map.getSource('properties')) map.removeSource('properties');
            if (spiderifier && typeof spiderifier.unspiderfy === 'function') {
                spiderifier.unspiderfy();
            }
            if (popup && popup.isOpen()) {
                popup.remove();
            }

            if (!properties.length) {
                return;
            }

            const geojson = {
                type: 'FeatureCollection',
                features: properties.map(property => ({
                    type: 'Feature',
                    properties: {
                        title: property.title || '',
                        listingType: property.listingType || '',
                        propertyType: property.propertyType || '',
                        price: property.price || '',
                        location: property.location || '',
                        size: property.size || '',
                        permalink: property.permalink || '',
                        thumbnail: property.thumbnail || ''
                    },
                    geometry: {
                        type: 'Point',
                        coordinates: [property.lng, property.lat]
                    }
                }))
            };

            map.addSource('properties', {
                type: 'geojson',
                data: geojson,
                cluster: true,
                clusterMaxZoom: 14,
                clusterRadius: 50
            });
  
            map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'properties',
                filter: ['has', 'point_count'],
                paint: {
                    'circle-color': '#004876',
                    'circle-radius': [
                        'step',
                        ['get', 'point_count'],
                        15,
                        5,
                        20,
                        10,
                        25,
                        20,
                        30
                    ],
                    'circle-stroke-width': 6,
                    'circle-stroke-color': 'rgba(0, 72, 118, 0.20)'
                }
            });
  
            map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'properties',
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': ['get', 'point_count_abbreviated'],
                    'text-font': ['Geist', 'Arial Unicode MS Bold'],
                    'text-size': 12
                },
                paint: { 'text-color': '#ffffff' }
            });
  
            map.addLayer({
                id: 'unclustered-point',
                type: 'circle',
                source: 'properties',
                filter: ['!', ['has', 'point_count']],
                paint: {
                    'circle-color': '#004876',
                    'circle-radius': 8,
                    'circle-stroke-width': 2,
                    'circle-stroke-color': '#fff'
                }
            });
  
            map.off('click', 'clusters', handleClusterClick);
            map.off('click', 'unclustered-point', handlePointClick);
            map.off('mouseenter', 'clusters', handleMouseEnter);
            map.off('mouseenter', 'unclustered-point', handleMouseEnter);
            map.off('mouseleave', 'clusters', handleMouseLeave);
            map.off('mouseleave', 'unclustered-point', handleMouseLeave);
  
            map.on('click', 'clusters', handleClusterClick);
            map.on('click', 'unclustered-point', handlePointClick);
            map.on('mouseenter', 'clusters', handleMouseEnter);
            map.on('mouseenter', 'unclustered-point', handleMouseEnter);
            map.on('mouseleave', 'clusters', handleMouseLeave);
            map.on('mouseleave', 'unclustered-point', handleMouseLeave);
        };
  
        if (propertyMapVars.properties && propertyMapVars.properties.length > 0) {
            map.on('load', () => {
                addPropertyLayers();
                fitMapToProperties();
                // Initial load should not filter by bounds until user interacts
                boundsFilterActive = false;
            });
  
            map.on('click', (e) => {
                // Ignore clicks that originate from spider legs or the popup
                const t = e && e.originalEvent && e.originalEvent.target;
                if (t && (t.closest && (t.closest('.spider-leg-container') || t.closest('.mapboxgl-popup')))) {
                    return;
                }
                if (popup.isOpen()) {
                    popup.remove();
                }
                if (spiderifier && typeof spiderifier.unspiderfy === 'function') {
                    spiderifier.unspiderfy();
                    if (spiderifiedPointMarker) {
                      spiderifiedPointMarker.remove();
                      spiderifiedPointMarker = null;
                    }
                }
            });

            // Close spiders on navigation
            map.on('move', () => { if (spiderifier && spiderifier.unspiderfy) spiderifier.unspiderfy(); 
              if (spiderifiedPointMarker) {
                spiderifiedPointMarker.remove();
                spiderifiedPointMarker = null;
              }
            });
            map.on('zoomstart', () => { if (spiderifier && spiderifier.unspiderfy) spiderifier.unspiderfy(); 
              if (spiderifiedPointMarker) {
                spiderifiedPointMarker.remove();
                spiderifiedPointMarker = null;
              }
            });

            
        }
        
        map.on('error', (e) => { if (e && e.error) console.error('Mapbox error:', e.error); });
  
        let switching = false;
  
        $container.on('click', '.map-style-btn', function(e) {
          e.preventDefault();
          const $btn = $(this);
          if ($btn.hasClass('active') || switching) return;
  
          const styleUrl = $btn.data('style');
          if (!styleUrl) return;
  
          const camera = {
            center: map.getCenter(),
            zoom: map.getZoom(),
            bearing: map.getBearing(),
            pitch: map.getPitch()
          };
  
          switching = true;
          $btn.addClass('loading').siblings().removeClass('active');
          $btn.addClass('active');
  
          map.setStyle(styleUrl);
  
          map.once('style.load', () => {
            map.jumpTo(camera);
            addPropertyLayers();
            fitMapToProperties();
            if (spiderifier && spiderifier.unspiderfy) spiderifier.unspiderfy();
            switching = false;
            $btn.removeClass('loading');
            map.resize();
            // Reapply bounds filter if active after style change
            if (boundsFilterActive) applyBoundsToList();
          });
        });
  
        $(document).on('click', '.studiothink-property-map__toggle button', function(e) {
          e.preventDefault();
          const $block = $(this).closest('.wp-block-st-property-map');
          if ($(this).hasClass('studiothink-property-map__toggle-map')) {
              $block.addClass('map-view');
              $block.removeClass('list-view');
          } else {
              $block.removeClass('map-view');
              $block.addClass('list-view');
          }
          map.resize();
          const top = $block.offset().top;
          $('html, body').scrollTop(top);
        });
  
        $(document).on('click', '.studiothink-property-map__filter-toggle', function(e) {
          e.preventDefault();
          const $wrapper = $(this).closest('.studiothink-property-map__search-wrapper');
          $wrapper.toggleClass('show-filters');
        });

        function formatPost(post) {
          if (!post.id) {
              return post.text;
          }
  
          var $container = $(`
              <div class="select2-result-properties">
                  <div class="select2-thumbnail">
                      <img src="${post.image}" width="100" height="50"/>
                  </div>
                  <div class="select2-content">
                    <div class="select2-title">${post.text}</div>
                    <div class="select2-info"><span>${post.listing_type} • ${post.city_province}</span><span>${post.price}</span></div>
                  </div>
              </div>
          `);
  
          return $container;
      }
  
        $('.property-search').select2({
          dropdownAutoWidth: true,
          multiple: false,
          theme: 'flat',
          minimumInputLength: 2,
          dropdownCssClass: "property-search-dropdown",
          ajax: {
            url: propertyMapVars.ajaxurl,
            dataType: 'json',
            delay: 250,
            data: function (params) {
                return {
                    action: 'select2_search_properties',
                    q: params.term,
                    nonce: propertyMapVars.nonce
                };
            },
            processResults: function (data) {
                return {
                    results: data.results
                };
            },
            cache: true
        },
        templateResult: formatPost,
        templateSelection: function (post) {
            return post.text || post.id;
        },
        minimumInputLength: 3,
        escapeMarkup: function (markup) { return markup; }
        });
  
        $('.property-search').one('select2:open', function() {
            $('input.select2-search__field').prop('placeholder', $('.property-search').data('placeholder'));
        });
  
        $('.property-search').on('select2:select', function (e) {
            const { permalink, id } = e.params.data || {};
            if (permalink) {
              window.location = permalink;
            } else if (id) {
              window.location = id;
            }
        });
  
        $('.select-filter').each(function() {
           $(this).select2({
            dropdownAutoWidth: true,
            multiple: false,
            theme: 'flat'
           });
        });

        const rangeErrorMessage = propertyMapVars.rangeErrorMessage || 'Minimum value must be less than or equal to the maximum value.';

        function parseFilterNumber(value) {
          if (value === null || value === undefined || value === '') return null;
          const normalized = String(value).replace(/,/g, '');
          const parsed = parseFloat(normalized);
          return Number.isNaN(parsed) ? null : parsed;
        }

        function validateFilterRanges($block) {
          const pairs = [
            { min: '#size_min', max: '#size_max' },
            { min: '#sale_price_min', max: '#sale_price_max' },
            { min: '#net_rent_min', max: '#net_rent_max' },
            { min: '#monthly_rent_min', max: '#monthly_rent_max' }
          ];

          let isValid = true;
          let firstInvalidEl = null;

          pairs.forEach(({ min, max }) => {
            const $min = $block.find(min);
            const $max = $block.find(max);

            if (!$min.length || !$max.length) return;

            const minEl = $min.get(0);
            const maxEl = $max.get(0);
            const minVal = parseFilterNumber($min.val());
            const maxVal = parseFilterNumber($max.val());

            if (minVal !== null && maxVal !== null && minVal > maxVal) {
              if (minEl && minEl.setCustomValidity) minEl.setCustomValidity(rangeErrorMessage);
              if (maxEl && maxEl.setCustomValidity) maxEl.setCustomValidity(rangeErrorMessage);
              if (!firstInvalidEl) firstInvalidEl = minEl || maxEl;
              isValid = false;
            } else {
              if (minEl && minEl.setCustomValidity) minEl.setCustomValidity('');
              if (maxEl && maxEl.setCustomValidity) maxEl.setCustomValidity('');
            }
          });

          if (!isValid) {
            if (firstInvalidEl && typeof firstInvalidEl.reportValidity === 'function') {
              firstInvalidEl.reportValidity();
            } else if (typeof window.alert === 'function') {
              window.alert(rangeErrorMessage);
            }
          }

          return isValid;
        }

        function gatherFilters($block) {
          const filters = {};
          $block.find('.map-filter').each(function() {
            const $el = $(this);
            const key = $el.data('filter');
            if (!key) return;

            const type = ($el.attr('type') || '').toLowerCase();

            if ($el.attr('name') === 'price_type') {
              // Don't need to do anything with price type
              return;
            }

            if (type === 'checkbox') {
              if (!$el.is(':checked')) return;
              if (!Array.isArray(filters[key])) {
                filters[key] = [];
              }
              filters[key].push($el.val());
              return;
            }

            if (type === 'radio') {
              if ($el.is(':checked')) {
                filters[key] = $el.val();
              }
              return;
            }

            // Handle other input types
            if ($el.val()) {
              filters[key] = $el.val();
            }
          });
          
          return filters;
        }

        function pushFiltersToUrl(filters) {
          const url = new URL(window.location.href);
          Array.from(url.searchParams.keys()).forEach(k => {
            url.searchParams.delete(k);
          });
          Object.keys(filters).forEach(key => {
            url.searchParams.set(key, filters[key]);
          });
          window.history.pushState({}, '', url.toString());
        }

        function clearFilterParams() {
          pushFiltersToUrl({});
        }

        function setPriceVisibility() {
          const selectedListingTypes = $('.map-filter[data-filter="listing_type"]:checked').map(function() {
            return $(this).val();
          }).get();
          
          if ((selectedListingTypes.includes('lease') || selectedListingTypes.includes('sublease')) && (!selectedListingTypes.includes('sale') && !selectedListingTypes.includes('sold') && !selectedListingTypes.includes('leased'))) {
            $('.price-sale').hide();
            $('.price-lease').css('display', 'flex');
          } else if (selectedListingTypes.includes('sale') && (!selectedListingTypes.includes('lease') && !selectedListingTypes.includes('sublease') && !selectedListingTypes.includes('sold') && !selectedListingTypes.includes('leased'))) {
            $('.price-sale').css('display', 'flex');
            $('.price-lease').hide();
          } else {
            $('.price-sale').hide();
            $('.price-lease').hide();
          }

          const selectedPriceType = $('.map-filter[name="price_type"]:checked').val();
          
          if (selectedPriceType === 'sqft') {
            $('.lease-sqft').show();
            $('.lease-month').hide();
          } else {
            $('.lease-sqft').hide();
            $('.lease-month').show();
          }
        }

        setPriceVisibility();

        $('.map-filter[data-filter="listing_type"]').on('change', function() {
          setPriceVisibility()
          $('.price-sale input:not([type="radio"]), .price-lease input:not([type="radio"]').val('');
        });

        $('.map-filter[name="price_type"]').on('change', function() {
          setPriceVisibility()
          $('.lease-sqft input, .lease-month input').val('');
        });



        // ----- Client-side sorting -----
        function readSortFromUrlOrDom() {
          const url = new URL(window.location.href);
          const sortParam = url.searchParams.get('sort');
          const $sort = $block.find('#sort-by');
          if (sortParam && $sort.length) {
            // If present in URL, set select (if value exists)
            if ($sort.find(`option[value="${sortParam}"]`).length) {
              $sort.val(sortParam).trigger('change.select2');
              return sortParam;
            }
          }
          // Fallback to current value
          return $sort.val() || 'Default';
        }

        function pushSortToUrl(sortVal) {
          const url = new URL(window.location.href);
          if (sortVal && sortVal !== 'Default') {
            url.searchParams.set('sort', sortVal);
          } else {
            url.searchParams.delete('sort');
          }
          window.history.pushState({}, '', url.toString());
        }

        function sortListItems(sortVal, options = {}) {
          const $list = $block.find('.studiothink-property-map__list-container');
          let $items = $list.find('.studiothink-property-map__list-item');
          if (!$items.length) return;

          // Always sort all items, but the visibility will be controlled separately
          const itemsArray = $items.toArray();

          const getNum = (el, attr) => {
            const v = parseFloat(el.getAttribute(attr));
            return isNaN(v) ? 0 : v;
          };

          itemsArray.sort((a, b) => {
            switch (sortVal) {
              case 'Price':
                return getNum(a, 'data-price') - getNum(b, 'data-price');
              case 'Price-desc':
                return getNum(b, 'data-price') - getNum(a, 'data-price');
              case 'Size':
                return getNum(a, 'data-size') - getNum(b, 'data-size');
              case 'Size-desc':
                return getNum(b, 'data-size') - getNum(a, 'data-size');
              case 'Date':
                // Newest first
                return getNum(b, 'data-date') - getNum(a, 'data-date');
              case 'Default':
              default:
                return getNum(a, 'data-index') - getNum(b, 'data-index');
            }
          });

          // Detach all items and re-append in sorted order
          $items.detach();
          $list.append(itemsArray);

          // Re-query items after DOM manipulation
          $items = $list.find('.studiothink-property-map__list-item');

          // Set visibility based on bounds filtering
          if (boundsFilterActive) {
            $items.each(function() {
              const $item = $(this);
              if ($item.hasClass('in-bounds')) {
                $item.show();
              } else {
                $item.hide();
              }
            });
          } else {
            $items.show();
          }

          // Recompute pagination and show page 1 after sorting
          computePaginationFromDom();
          renderPaginationPage(1, options);
        }

        // Client-side pagination state and helpers
        let pagination = { itemsPerPage: 5, currentPage: 1, totalPages: 1, $items: $() };

        function computePaginationFromDom() {
          const $list = $block.find('.studiothink-property-map__list-container');
          // Only paginate currently visible items so bounds filtering is respected
          const $items = $list.find('.studiothink-property-map__list-item:visible');
          pagination.$items = $items;
          const count = $items.length;
          pagination.totalPages = Math.max(1, Math.ceil(count / pagination.itemsPerPage));
          pagination.currentPage = Math.min(pagination.currentPage, pagination.totalPages) || 1;
          updatePaginationIndicator();
        }

        function renderPaginationPage(page, { scroll = false } = {}) {
          if (!pagination.$items || !pagination.$items.length) {
            updatePaginationIndicator();
            return;
          }
          pagination.currentPage = Math.min(Math.max(1, page), pagination.totalPages);
          const start = (pagination.currentPage - 1) * pagination.itemsPerPage;
          const end = start + pagination.itemsPerPage;
          pagination.$items.hide().slice(start, end).show();
          updatePaginationIndicator();
          updatePaginationButtons();
          // Scroll the list container back to top for UX
          const $list = $block.find('.studiothink-property-map__list-container');
          if ($list.length) {
            $list.scrollTop(0);
          }
          if (scroll) {
            // Scroll the window to the top of the list
            const offset = $('.wp-block-st-property-map').offset();
            if (offset) {
              $('html, body').animate({
                scrollTop: offset.top - 100
              }, 500);
            }
          }
        }

        function updatePaginationIndicator() {
          const $pageEl = $block.find('.studiothink-property-map__pagination-page');
          if ($pageEl.length) {
            $pageEl.text(`Page ${pagination.currentPage} of ${pagination.totalPages}`);
          }
        }

        function updatePaginationButtons() {
          const $prev = $block.find('.studiothink-property-map__pagination-button--prev');
          const $next = $block.find('.studiothink-property-map__pagination-button--next');
          const prevDisabled = pagination.currentPage <= 1;
          const nextDisabled = pagination.currentPage >= pagination.totalPages;
          if ($prev.length) {
            $prev.prop('disabled', prevDisabled);
            $prev.attr('aria-disabled', prevDisabled ? 'true' : 'false');
          }
          if ($next.length) {
            $next.prop('disabled', nextDisabled);
            $next.attr('aria-disabled', nextDisabled ? 'true' : 'false');
          }
        }

        function initPagination() {
          computePaginationFromDom();
          // Read page from URL if present
          const url = new URL(window.location.href);
          const pageParam = parseInt(url.searchParams.get('page') || '1', 10);
          const initialPage = isNaN(pageParam) ? 1 : pageParam;
          renderPaginationPage(initialPage, { scroll: false });
          bindPaginationControls();
        }

        function bindPaginationControls() {
          // Unbind first to avoid duplicates
          $block.off('click', '.studiothink-property-map__pagination-button--prev');
          $block.off('click', '.studiothink-property-map__pagination-button--next');
          $block.on('click', '.studiothink-property-map__pagination-button--prev', function(e){
            e.preventDefault();
            const nextPage = pagination.currentPage - 1;
            renderPaginationPage(nextPage, { scroll: true });
            pushPageToUrl(nextPage);
          });
          $block.on('click', '.studiothink-property-map__pagination-button--next', function(e){
            e.preventDefault();
            const nextPage = pagination.currentPage + 1;
            renderPaginationPage(nextPage, { scroll: true });
            pushPageToUrl(nextPage);
          });
        }

        function pushPageToUrl(pageNumber) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', pageNumber);
          window.history.pushState({}, '', url.toString());
        }

        // Initialize pagination for initial DOM
        initPagination();

        // Initialize sorting from URL or current select value, then respect page param
        const initialSort = readSortFromUrlOrDom();
        sortListItems(initialSort, { scroll: false });
        (function(){
          const url = new URL(window.location.href);
          const pageParam = parseInt(url.searchParams.get('page') || '1', 10);
          const page = isNaN(pageParam) ? 1 : pageParam;
          if (page > 1) renderPaginationPage(page, { scroll: false });
        })();

        // Bind sort change
        $block.on('change', '#sort-by', function(){
          const val = $(this).val() || 'Default';
          pushSortToUrl(val);
          sortListItems(val, { scroll: true });
        });

        // Sync pagination with browser navigation
        window.addEventListener('popstate', function(){
          const url = new URL(window.location.href);
          const sortParam = url.searchParams.get('sort') || 'Default';
          // Set select without triggering duplicate change side-effects
          const $sort = $block.find('#sort-by');
          if ($sort.length && $sort.find(`option[value="${sortParam}"]`).length) {
            $sort.val(sortParam).trigger('change.select2');
          }
          // Apply sort then page
          sortListItems(sortParam, { scroll: false });
          const pageParam = parseInt(url.searchParams.get('page') || '1', 10);
          const page = isNaN(pageParam) ? 1 : pageParam;
          renderPaginationPage(page, { scroll: true });
        });

        function applyFilterResults($block, res) {
          if (!res || !res.success) return;
          const data = res.data || {};
          const $list = $block.closest('.wp-block-st-property-map').find('.studiothink-property-map__list-container');
          if ($list.length) {
            $list.html(data.html || '');
          }
          if (typeof data.count !== 'undefined') {
            const $count = $block.find('.results-count__number');
            if ($count.length) {
              $count.text(data.count);
            }
          }
          if (Array.isArray(data.markers)) {
            propertyMapVars.properties = data.markers;
            addPropertyLayers();
            fitMapToProperties();
            // Reset bounds after filters change to show all filtered results
            boundsFilterActive = false;
            showAllListItems();
          }
          // Reinitialize pagination after list HTML updates
          computePaginationFromDom();
          // Apply current sort from URL, then reset to page 1
          const sortVal = readSortFromUrlOrDom();
          sortListItems(sortVal, { scroll: false });
          renderPaginationPage(1, { scroll: true });
          pushPageToUrl(1);
        }
  
        $(document).on('click', '#apply-property-filters', function(e) {
          e.preventDefault();
          const $block = $(this).closest('.wp-block-st-property-map');
          if (!validateFilterRanges($block)) {
            return;
          }
          const filters = gatherFilters($block);

          pushFiltersToUrl(filters);

          $.ajax({
            url: propertyMapVars.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
              action: 'st_property_filters',
              nonce: propertyMapVars.nonce || '',
              filters: filters
            }
          }).done(function(res) {
            applyFilterResults($block, res);
            $block.find('.studiothink-property-map__search-wrapper').removeClass('show-filters');
            // Close any popups on map
            popup.remove();
          }).fail(function(xhr) {
            console.error('Property filter request failed', xhr);
          });
        });
  
        $(document).on('click', '#clear-property-filters', function(e) {
          e.preventDefault();
          const $block = $(this).closest('.wp-block-st-property-map');
          $block.find('.map-filter').each(function() {
            const $el = $(this);
            const type = ($el.attr('type') || '').toLowerCase();
            if (type === 'checkbox' || type === 'radio') {
              $el.prop('checked', false).trigger('change');
            } else {
              $el.val('').trigger('change');
            }
            if (this && this.setCustomValidity) {
              this.setCustomValidity('');
            }
          });
          clearFilterParams();

          $.ajax({
            url: propertyMapVars.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
              action: 'st_property_filters',
              nonce: propertyMapVars.nonce || '',
              filters: {}
            }
          }).done(function(res) {
            applyFilterResults($block, res);
            $block.find('.studiothink-property-map__search-wrapper').removeClass('show-filters');
            // Reset bounds completely after clearing filters
            boundsFilterActive = false;
            showAllListItems();
          }).fail(function(xhr) {
            console.error('Clear property filters request failed', xhr);
          });
        });

        $block.on('input change', '.map-filter', function() {
          if (this && this.setCustomValidity) {
            this.setCustomValidity('');
          }
        });

        // Bind bounds-based filtering after map is ready
        map.on('moveend', function() {
          boundsFilterActive = true;
          applyBoundsToList();
        });
        map.on('zoomend', function() {
          boundsFilterActive = true;
          applyBoundsToList();
        });
      });
    });
})(jQuery);
